<template>
  <div v-if="loading === false">
    <div class="formSection__Row--Group">
      <p>
        <label class="formLabel" for="firstName">{{ $store.getters.getStringTranslation('fullName') }}</label>
        <input v-model="item.name" class="formInput" type="text" id="firstName" />
      </p>
    </div>
    <div class="formSection__Row--Group">
      <ul class="cardPreview__Meta">
        <li v-for="translation in langs" :key="translation.id">
          <!-- Regular link for exising translation -->
          <template v-if="l10n[translation.toLowerCase()]">
            <router-link class="cardPreview__MetaLink" :to="translationURL(translation)">
              {{ translation }}
              <icon
                name="check"
                v-if="l10n[translation.toLowerCase()].foreword && l10n[translation.toLowerCase()].description"
              ></icon>
            </router-link>

            <button v-if="item.l10n.length > 1" class="cardPreview__MetaPopup" @click="removeTranslation(translation)">
              <icon name="times"></icon>{{ $store.getters.getStringTranslation('remove') }}
            </button>
          </template>

          <!-- New translation -->
          <button class="cardPreview__MetaLink--Add" @click="addTranslation(translation)" v-else>
            {{ translation }}
            <icon name="plus" weight="solid"></icon>
          </button>
        </li>
      </ul>
      <template v-if="l10n">
        <p>
          <label class="formLabel" for="position">{{ $store.getters.getStringTranslation('position') }}</label>
          <input v-model="l10n[lang].position" class="formInput" type="text" id="position" />
        </p>
        <p>
          <label class="formLabel">{{ $store.getters.getStringTranslation('foreword') }}</label>
          <text-editor v-model="l10n[lang].foreword" />
        </p>
        <p>
          <label class="formLabel">{{ $store.getters.getStringTranslation('description') }}</label>
          <text-editor v-model="l10n[lang].description" />
        </p>
      </template>
    </div>
    <div class="formSection__Row">
      <p v-if="currentUser.is_admin || currentUser.is_org_admin">
        <label class="formLabel" for="position">{{ $store.getters.getStringTranslation('order') }}</label>
        <input v-model="item.order" class="formInput" type="number" id="order" />
        <span class="note">{{ $store.getters.getStringTranslation('orderDesc') }}</span>
      </p>
      <p>
        <label class="formLabel" for="governance_order">Governance order</label>
        <input
          v-model="item.contents.additionals.governance_order"
          class="formInput"
          type="text"
          id="governance_order"
        />
      </p>
      <p>
        <label class="formLabel" for="governance_order">Governance position</label>
        <input
          v-model="item.contents.additionals.governance_position"
          class="formInput"
          type="text"
          id="governance_position"
        />
      </p>
      <p>
        <label class="formLabel" for="phone">{{ $store.getters.getStringTranslation('phone') }}</label>
        <input v-model="item.contents.additionals.phone" class="formInput" type="text" id="phone" />
      </p>
      <p>
        <label class="formLabel" for="facebook">Facebook</label>
        <input v-model="item.contents.additionals.facebook" class="formInput" type="text" id="facebook" />
      </p>
      <p>
        <label class="formLabel" for="twitter">Twitter</label>
        <input v-model="item.contents.additionals.twitter" class="formInput" type="text" id="twitter" />
      </p>
      <p>
        <label class="formLabel" for="medium">Medium</label>
        <input v-model="item.contents.additionals.medium" class="formInput" type="text" id="medium" />
      </p>
      <p>
        <label class="formLabel">{{ $store.getters.getStringTranslation('profilePicture') }}</label>
        <image-upload :required="true" v-model="item.contents.thumbnail_urls"></image-upload>
      </p>

      <div class="formSection__Row--Select" v-for="taxonomy in taxonomies" :key="taxonomy.id">
        <search-tag
          class="formSearchWrapper--Tags"
          :showLabel="false"
          :types="[taxonomy.name]"
          :lang="lang"
          :placeholder="`Choose ${taxonomy.name}`"
          :icon="taxonomy.icon"
          :tags="item.tags.filter((tag) => tag.type === taxonomy.name)"
          v-model="taxonomy.data"
          @onchange="syncTags"
          @handleParentTag="setParentTag"
          :countryParentTag="taxonomy.name === 'region' ? countryParentTag : null"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ISOlanguages } from '@/router/globals.js'
import ManageTranslations from '@/components/mixins/ManageTranslations.js'
import ReduceItemData from '@/components/mixins/ReduceItemData.js'
import TextEditor from '@/components/editor/TextEditor.vue'
import ImageUpload from '@/components/editor/ImageUpload.vue'
import SearchTag from '@/components/editor/blocks/SearchTag.vue'

export default {
  props: ['user', 'loading'],
  components: {
    TextEditor,
    ImageUpload,
    SearchTag,
  },
  mixins: [ManageTranslations, ReduceItemData],
  computed: {
    // Return lang data from URL query, if query exists
    lang() {
      if (this.$route.query.lang !== undefined) {
        return this.$route.query.lang
        //  If not, retrieve language from search parameters
      } else {
        return this.item.l10n[0].lang ? this.item.l10n[0].lang : 'en'
      }
    },
    langs() {
      return ISOlanguages
    },
    item: {
      get() {
        let user = this.user
        if (this.l10n.name === undefined) this.transformTranslationData(user.l10n)
        return user
      },
      set(val) {
        this.transformTranslationData(val.l10n)
        this.$emit('input', val)
      },
    },
    currentUser() {
      return this.$store.state.accounts.user
    },
  },
  data() {
    return {
      countryParentTag: null,
      taxonomies: [
        { name: 'sector', icon: 'bullseye', data: [] },
        { name: 'organisation', icon: 'users', data: [] },
        { name: 'country', icon: 'map', data: [] },
        { name: 'region', icon: 'globe', data: [] },
      ],
    }
  },
  methods: {
    syncTags() {
      const tags = this.taxonomies.map((taxonomy) => taxonomy.data)
      this.item.tag_ids = [].concat.apply([], tags)
    },

    setParentTag(tag) {
      this.countryParentTag = tag
    },
  },
}
</script>
